<template>
  <v-container>
    <v-card>
      <v-layout row
                wrap>
        <v-flex xs12
                class="pa-2">

          <v-list class="n-lines">
            <v-subheader>Condiciones promoción Madrid Enero 2020</v-subheader>
            <v-list-tile v-for="item in items"
                         class="pa-2"
                         :key="item.title">
              <v-list-tile-action>
                <v-icon color="primary">check</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-subtile v-text="item.title"
                                     style="font-size:14px"></v-list-tile-subtile>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'PromoMadridEnero20',
  data() {
    return {
      items: [
          { title: 'Podrán participar de la presente promoción todos los usuarios de wesmartPark que aparquen 3 veces o más durante el mes de Enero de 2020 en Madrid.' },
          { title: 'No se incluirán en la presente promoción los abonos, tan solo las reservas por horas.' },
          { title: 'Para considerar que un usuario ha aparcado en wesmartPark la reserva debe materializarse. No se aceptarán reservas canceladas como objeto de la promoción.' },
          { title: 'La promoción se canjeará en forma de saldo wesmartPark.' },
          { title: 'Esta promoción no es acumulativa, por lo que la participación se realizará una sola vez, a saber, si un usuario de wesmartPark realizase 6 reservas dispondrá de 1 promoción, no de 2.' },
          { title: 'Las personas que cumplan con las condiciones previas recibirán el abono de la reserva de menor precio el 4 de Febrero en saldo wesmartPark que podrán usar sin fecha de caducidad.' }
        ]
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
